var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigMoveUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.03L4.827 9.203l1.179 1.178L10 6.387l3.994 3.994 1.179-1.178L10 4.03zm0 4.708l-5.173 5.173 1.179 1.178L10 11.095l3.994 3.994 1.179-1.178L10 8.738z",
    fill: "#3DDF2F"
  })));
}
export default __webpack_public_path__ + "static/svg/big-move-up.svg";
export { SvgBigMoveUp as ReactComponent };